import {
  AspectRatio,
  Box,
  BoxProps,
  DiscountBadge,
} from "@vinomofo/components";

import { GatsbyImage } from "gatsby-plugin-image";
import { OfferSoldOut } from "./OfferSoldOut";
import { Roundel } from "../roundel";
import { StorefrontImage } from "../../types";
import styled from "styled-components";
import { DiscountDisplay } from "../../types/vino-data-types";
import { discountDisplays } from "../../utils/constants";

export interface OfferHeroImageProps extends BoxProps {
  image: StorefrontImage;
  roundelsImage?: StorefrontImage;
  isAvailable: boolean;
  discountPercent: number;
  discountDisplay: DiscountDisplay;
  discountDollarValue: number;
  showDiscountBadge: boolean;
}

const StyledOfferSoldOut = styled(OfferSoldOut)`
  transform: translateX(-50%);
  left: 50%;
  top: 50px;
`;

const StyledDiscountBadge = styled(DiscountBadge)`
  right: 0;
  top: -13px;
  > span:first-of-type {
    font-size: 22px;
  }
  > p:first-of-type {
    font-size: 10px;
  }
`;

export const MarqueeOfferHeroImage = ({
  image,
  isAvailable,
  discountPercent,
  discountDisplay,
  discountDollarValue,
  showDiscountBadge,
  roundelsImage,
  ...rest
}: OfferHeroImageProps): JSX.Element => {
  return (
    <Box position="relative" {...rest}>
      <AspectRatio ratio={1}>
        <GatsbyImage
          image={image}
          style={{ width: "100%", height: "100%", textAlign: "center" }}
          imgStyle={{
            objectFit: "contain",
            objectPosition: "bottom center",
            top: "auto",
            bottom: "0",
            width: "100%",
            height: "100%",
          }}
          alt=""
        />
      </AspectRatio>
      {!isAvailable && <StyledOfferSoldOut position="absolute" />}
      {isAvailable && showDiscountBadge && (
        <StyledDiscountBadge
          position="absolute"
          discountDisplay={discountDisplay}
          amount={
            discountDisplay === discountDisplays.dollar
              ? discountDollarValue
              : discountPercent
          }
          left={["calc(50%)"]}
          marginLeft={-60}
          top={"50px !important"}
          variant="lg"
        />
      )}
      {roundelsImage && (
        <Roundel
          width={["52px", "60px", "80px"]}
          height={["52px", "60px", "80px"]}
          isExpired={!isAvailable}
          image={roundelsImage}
          bottom="30px"
          left={["calc(60%)", "calc(60%)", "calc(60%)"]}
          zIndex="1"
        />
      )}
    </Box>
  );
};
